module.exports = __webpack_public_path__ + "static/media/conservative.bb537030.svg";